import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const ListaImpedimentos = ({ formik, field, ativar }) => {
  const [impedimento, setImpedimento] = useState([]); // lista de motivos de impedimento parametrizados [sequencialImpedimento, textoImpedimento]
  const [showErro, setShowErro] = useState(false);
  const [messageErro, setMessageErro] = useState("");
  const { request, data, errors, isLoading } = useApiClient();

  useEffect(() => {
    if (ativar) {
      request(apiRoutes.fiscalizacao.ordemservico.consultaImpedimentos);
    }
  }, [request, ativar]);

  useEffect(() => {
    if (data) {
      setShowErro(false);
      setImpedimento(data.result);
    }

    if (errors) {
      setMessageErro(errors.message);
      setShowErro(true);
    }
  }, [data, errors]);

  const { setValues } = formik;

  useEffect(() => {
    setValues((curr) => {
      const newValues = { ...curr };
      if (curr.sequencialImpedimento === "") {
        newValues.impedimentos = [];
      }
      return newValues;
    });
  }, [setValues]);

  const changeHandler = (event) => {
    const updatedImpedimentos = [...formik.values[field]];
    if (event.target.checked && updatedImpedimentos.indexOf(event.target.id) === -1) {
      updatedImpedimentos.push(event.target.id);
    } else {
      updatedImpedimentos.splice(updatedImpedimentos.indexOf(event.target.id), 1);
    }
    formik.setFieldValue(field, updatedImpedimentos);
  };

  if (showErro) {
    return (
      <>
        <br />
        <div className="alert alert-danger" role="alert">
          {messageErro}
        </div>
      </>
    );
  }

  if (isLoading) {
    return (
      <span>
        <Spinner animation="border" role="status" />
        Carregando Motivos de Impedimento...
      </span>
    );
  }

  if (!impedimento?.length) {
    return null;
  }

  return (
    <>
      <Form.Label>Motivo de Impedimento</Form.Label>
      {impedimento.map((item) => (
        <Form.Check
          key={item.sequencialImpedimento}
          type="checkbox"
          id={item.sequencialImpedimento}
          name={field}
          label={item.textoImpedimento}
          disabled={formik.isSubmitting}
          defaultChecked={
            !!formik.values[field].find((element) => parseInt(element, 10) === item.sequencialImpedimento)
          }
          onChange={(event) => changeHandler(event)}
        />
      ))}
      {formik.errors[field] && <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>}
    </>
  );
};

export default ListaImpedimentos;
